import { render, staticRenderFns } from "./NewContentBox.vue?vue&type=template&id=7c86d00c&scoped=true&"
import script from "./NewContentBox.vue?vue&type=script&lang=js&"
export * from "./NewContentBox.vue?vue&type=script&lang=js&"
import style0 from "./NewContentBox.vue?vue&type=style&index=0&id=7c86d00c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86d00c",
  null
  
)

component.options.__file = "NewContentBox.vue"
export default component.exports